import React from 'react'

import { DefaultLayoutProps } from './interfaces'

import cm from './DefaultLayout.module.css'

export const DefaultLayout = ({ count, label }: DefaultLayoutProps) => (
  <div className="o-hidden">
    <div className="row gutter p-x p-y-xs">
      <div className={cm.optionLabel}>{label}</div>
      <div className="col-auto text-secondary">{count}</div>
    </div>
  </div>
)
